export default {"src":"https://fishbrain.com/_next/static/media/blackCrappie.5bc8a770.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};